import DeviceStore from "./DeviceStore";
const DeviceStoreInstance = new DeviceStore();

export default {
  DeviceStore: DeviceStoreInstance,
}
